<template>
    <div class="reportes-section">
        <div class="reportes-content">
            <h2 class="reportes-title fuente-posm">
                Reportes de Seguimiento.<br>
                <span>Acorde a tu Marca</span>
            </h2>
            <p class="reportes-text fuente-nova">
                Cada semana enviaremos una recopilación del feedback generado por tus clientes.
                <br><br>
                Descubrirás el progreso de métricas clave para tu negocio, cómo NPS (Net Promoter Score).
            </p>
        </div>
        <div class="reportes-image">
            <img :src="a53" alt="Reportes">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportesFeedbackNew',
    data() {
        return {
            a53: require('@/assets/images/a53.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.reportes-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.reportes-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.reportes-image img {
    width: 500px;
    height: auto;
}

.reportes-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.reportes-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.reportes-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .reportes-title {
        font-size: 60px;
    }

    .reportes-text {
        font-size: 27px;
    }

    .reportes-image img {
        width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .reportes-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .reportes-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .reportes-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .reportes-image img {
        width: 100%;
        max-width: 350px;
    }

    .reportes-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .reportes-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
